import React from 'react';
import useIvw from 'app/services/ivw/useIvw';

const Ivw = props => {
  useIvw(props.partner, props.hasIvwValues);
  return null;
};

export default Ivw;
